import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-circle',
  templateUrl: './circle.component.html',
  styleUrls: ['./circle.component.css']
})
export class CircleComponent implements OnChanges {

  constructor() { }
  @Input() progress: number = 50; // Default progress value
  @Input() total: number = 100; // Default total
  @Input() circleText!: string
  @Input() count!: number
  @Input() circleColor!: string
  @Input() circleBackColor!: string

  circumference: number = 2 * Math.PI * 80; // Pre-calculate circumference based on radius
  dashOffset: number = this.calculateDashOffset();

  ngOnChanges(_: SimpleChanges): void {
    this.updateProgress();
  }

  updateProgress() {
    this.dashOffset = this.calculateDashOffset();
  }

  private calculateDashOffset() {
    if (this.total <= 0) return this.circumference;
    if (this.progress >= this.total) return 0;
    return this.circumference * (this.total - this.progress) / this.total;
  }
}
